export const dateFilterStyle = ({ palette = {}, iconFontFamily = 'MsAds MDL2 Assets' }) => ({
  '& .date-filter': {
    '& .dropdown-menu': {
      border: `1px solid ${palette.neutralTertiary}`,
      borderTop: 0,
      borderRadius: 0,
      minWidth: 390,
      marginLeft: -15,
      boxShadow: 'none',

      '& .customDateRangePanel ': {
        width: 200,
        '& >div': {
          display: 'flex',
        },
        '& .datePicker': {
          // border: `1px solid ${palette.neutralTertiary}`,
          border: 0,
          background: palette.white,
          '& input': {
            height: 20,
            paddingLeft: 4,
            lineHeight: '16px',
            fontSize: 12,
            textAlign: 'center',
          },
        },
      },

      '& .customTimeRangePanel': {
        width: 280,
        '& >div': {
          display: 'flex',
          flexWrap: 'wrap',
        },
        '& .datePicker, .timePicker': {
          // border: `1px solid ${palette.neutralTertiary}`,
          border: 0,
          background: palette.white,
          width: 90,

          '& input': {
            height: 20,
            paddingLeft: 4,
            lineHeight: '16px',
            fontSize: 12,
            textAlign: 'center',
          },
        },
        '& .errors': {
          fontSize: 12,
          color: palette.red,
        },
      },
    },

    '& .dropdown-menu .dividerPanel': {
      padding: '7px 10px',
    },
    '& .date-range a': {
      padding: '7px 10px',
      display: 'block',
      clear: 'both',
      fontSize: 14,
      fontWeight: 'normal',
      lineHeight: 1.45833333,
      color: `${palette.neutralPrimary}`,
      whiteSpace: 'nowrap',
      cursor: 'pointer',
      textDecoration: 'none',
      '&:hover': {
        'background-color': `${palette.neutralLight}`,
      },
    },
    '& .glyphicon-offset-left5': {
      marginRight: 5,
      marginLeft: -5,
      width: 12,
    },
    '& .dropdown-toggle': {
      border: `1px solid ${palette.neutralTertiary}`,
      borderRadius: 0,
      boxShadow: 'none',
      paddingLeft: 10,
      minWidth: 390,
      backgroundColor: `${palette.white} !important`,
      '& .type-bold.primary-range': {
        fontWeight: 400,
      },
    },
    '& .dropdown-toggle > div': {
      '&:after': {
        content: '',
        display: 'block',
        clear: 'both',
      },
    },
    '& .dropdown-toggle .glyphicon-triangle-bottom': {
      position: 'absolute',
      top: '50%',
      transform: 'translateY(-50%)',
    },
    '& .dropdown-toggle .glyphicon-triangle-bottom:before': {
      fontFamily: iconFontFamily,
      content: '"\\E787"',
    },
    '& .toggle-button': {
      width: 40,
      height: 20,
      padding: 4,
      lineHeight: 10,
    },
  },
});
